import dayjs from 'dayjs';
import { mainData } from '../stores.js';
import { BigNumber } from 'bignumber.js';
import { writable } from 'svelte/store';
import { blank_object } from 'svelte/internal';

export const chartOpbouw = writable({});
export const chartAfbouw = writable({});
export const optionsOpbouw = writable({});
export const optionsAfbouw = writable({});
BigNumber.config({ DECIMAL_PLACES: 10 });
export function updateData() {
    // Subscribe to Global Storage
    let data, opbouw, afbouw, chartoptions;
    mainData.subscribe(value => { data = value; });
    chartOpbouw.subscribe(value => { opbouw = value; });
    chartAfbouw.subscribe(value => { afbouw = value; });
    optionsOpbouw.subscribe(value => { chartoptions = value} );
    
    
    chartOpbouw.set(datasetOpbouw(data));
    chartAfbouw.set(datasetAfbouw(data));
    optionsOpbouw.set(optionsOpbouwFunc()); 
    optionsAfbouw.set(optionsAfbouwFunc()); 

    //console.info("I refreshed the database hurray!");


    // Not sure why maar unsubscribe hier voor de zekerheid
    mainData.subscribe(value => { data = value; });
    chartOpbouw.subscribe(value => { opbouw = value; });
    chartAfbouw.subscribe(value => { afbouw = value; });
    optionsOpbouw.subscribe(value => { chartoptions = value} );

};

const getChartData = function(type) {
    if(type == "opbouw"){
      return chartOpbouw;
    } else if (type == "afbouw"){
      return chartAfbouw;
    } else {
      //console.log("I'm really confused");
    }
};


const optionsOpbouwFunc = function() {
  let chartData;
  getChartData("opbouw").subscribe(value => {chartData = value});

    return {
    chart: {
      type: "area",
      stacked:"true",
      height: '100%',
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: 'straight',
    },
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        name: "Lening",
        data: chartData.totaalLening,
      },{
        name: "Collegegeldkrediet",
        data: chartData.totaalColl,
      },{
        name: "Aanvullende Beurs",
        data: chartData.totaalAanv,
      },{
        name: "Reisproduct",
        data: chartData.totaalReis,
      },
    ],
    yaxis: {
      labels: {
        formatter: function(value){
          var val = new BigNumber(value);
          return val.toFormat(2);
        }
      }
    },
    xaxis: {
      type: "datetime",
      showDuplicates: false,
      labels: {
        format: "yyyy"
      }
    },
    tooltip: {
      x: {
        formatter: function(val, w) {
          let date = dayjs(val).format("MMM YYYY");
          let value = new BigNumber(chartData.totaalSchuld[w.dataPointIndex]);
          return date + " - " + value.toFormat(2);
        }
      }
    },
    annotations: {
        yaxis: [
          {
            y: chartData.totaalLening.slice(-1)[0].y.plus(chartData.totaalColl.slice(-1)[0].y).toNumber(),
            borderColor: '#000000',
            label: {
              borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396'
              },
              text: 'Eindschuld (excl. prestatiebeurs)'
            }
          }
        ],
        position: 'front',
        texts: [{ 
          text: 'WAT DE STUFI?!', 
          textAnchor: 'middle',
          fontSize: '50px',
          foreColor: 'rgba(0,0,0,0.05)',
          fontFamily: 'Staatliches',
          x: '50%',
          y: '50%',
        },
        { 
          text: 'Jouw Opbouwfase', 
          textAnchor: 'middle',
          fontSize: '25px',
          foreColor: 'rgba(0,0,0,1)',
          fontFamily: 'Staatliches',
          x: '50%',
          y: '20px',
        },
      ]
    }
  }};

const optionsAfbouwFunc = function() {
    let chartData;
    getChartData("afbouw").subscribe(value => {chartData = value});
  
      return {
        chart: {
          type: "area",
          stacked: false,
          width: '100%',
          zoom: {
            enabled: false,
          },
        },
        stroke: {
          curve: 'straight',
        },
        dataLabels: {
          enabled: false,
        },
        series: [
          /*{
            name: "Totale Schuld",
            data: chartData.totaalSchuld,
          },*/{
            name: "Totale Schuld",
            data: chartData.totaalSchuld,
            color: "red",
          },{
            name: "waarvan onbetaalde rente",
            data: chartData.extraRente,
            color: "maroon",
          },
          {
            name: "Totaal Betaald",
            data: chartData.totaalBetaald,
            color: "limegreen",
          },{
            name: "waarvan rente",
            data: chartData.totaalRente,
            color: "green",
          },
        ],
        yaxis: {
          min: 0,
          forceNiceScale: true,
          labels: {
            formatter: function(value){
              var val = new BigNumber(value);
              return val.toFormat();
            }
          }
        },
        xaxis: {
          type: "datetime",
          showDuplicates: false,
          labels: {
            format: "yyyy"
          }
        },
        tooltip: {
          x: {
            formatter: function(val, w) {
              let date = dayjs(val).format("MMM YYYY");
              let value = new BigNumber(0);
              if(w.dataPointIndex != undefined){
                value = BigNumber(chartData.totaalSchuld[w.dataPointIndex].y);
              }
              return date + " - " + value.toFormat(2);
            }
          }
        },
        annotations: {
            yaxis: [
              {
                y: chartData.totaalSchuld[0].y,
                borderColor: '#000000',
                borderWidth: 2,

                label: {
                  borderColor: 'black',
                  borderRadius:0,
                  strokeDashArray: 1,
                  offsetX: -50,
                  offsetY: 10,
                  style: {
                    color: 'black',
                    background: 'white',
                    fontFamily: 'Staatliches',
                    fontSize: '18px',

                    padding: {
                      left: 5,
                      right: 5,
                      top: 2,
                      bottom: 2,
                    }
                  },
                  text: 'Startschuld',
                }
              }
            ],
            position: 'front',
            texts: [{ 
              text: 'WAT DE STUFI?!', 
              textAnchor: 'middle',
              fontSize: '50px',
              foreColor: 'rgba(0,0,0,0.1)',
              fontFamily: 'Staatliches',
              x: '50%',
              y: '50%'
              },
              { 
                text: 'Jouw Aflosfase', 
                textAnchor: 'middle',
                fontSize: '25px',
                foreColor: 'rgba(0,0,0,1)',
                fontFamily: 'Staatliches',
                x: '50%',
                y: '20px',
              }]
    }
  }};

function datasetOpbouw(data){
  // Convert numbers to BigNumbers
  let aanvullend  = new BigNumber(data.aanvullend);
  let reisproduct = new BigNumber(data.reisproduct);
  let collegegeld = new BigNumber(data.collegegeld);
  let lening      = new BigNumber(data.lening);

  // Hoeveel maanden in totaal?
  let beginOpbouw = new Date(data.beginMaand);
  let eindOpbouw = new Date(data.eindMaand);

  // Bereken lening per maand:
  let totaleSchuld = new BigNumber(0);
  let maandenOpbouwfase = eindOpbouw.getMonth() - beginOpbouw.getMonth() + 1 + (12 * (eindOpbouw.getFullYear() - beginOpbouw.getFullYear()));
  let leningPerMaand =                lening.dividedBy(maandenOpbouwfase); // AANNAME: Lening verandert niet over maanden heen
  let collegegeldkredietPerMaand =    collegegeld.dividedBy(maandenOpbouwfase) // AANNAME: Lening verandert niet over maanden heen
  let aanvullendPerMaand =            aanvullend.dividedBy(maandenOpbouwfase) // AANNAME: Lening verandert niet over maanden heen
  let reisproductPerMaand =           reisproduct.dividedBy(maandenOpbouwfase) // AANNAME: Lening verandert niet over maanden heen

  // Bereken collegegeldkrediet per maand:
  // Bereken max aflossing per maand
  let i           = beginOpbouw;
  let dataset     = [];
  let tot_schuld  = new BigNumber(0);
  let tot_aanv    = new BigNumber(0);
  let tot_college = new BigNumber(0);
  let tot_reis    = new BigNumber(0);
  let tot_len     = new BigNumber(0);

 // console.log(i);
  while (i <= eindOpbouw) {
      // i = de te berekenen maand
      let maandVerschil = 0;
      if (i <= eindOpbouw) {
          // Opbouwfase: 
          tot_aanv      = tot_aanv.plus(aanvullendPerMaand);
          tot_college   = tot_college.plus(collegegeldkredietPerMaand);
          tot_reis      = tot_reis.plus(reisproductPerMaand);
          tot_len       = tot_len.plus(leningPerMaand);
          tot_schuld    = tot_aanv.plus(tot_college).plus(tot_reis).plus(tot_len);
        
      } else {
          // Bereken aflossing:
      }

      
      dataset.push({
          'date': new Date(i),
          'month': i.toLocaleString('nl-NL', { month: 'long' }),
          'year': i.toLocaleString('nl-NL', { year: 'numeric' }),
          'lening':               leningPerMaand,
          'collegegeldkrediet':   collegegeldkredietPerMaand,
          'reisproduct':          reisproductPerMaand,
          'aanvullendebeurs':     aanvullendPerMaand,
          'totaal_schuld':        tot_schuld,
          'totaal_aanvullend':    tot_aanv,
          'totaal_college':       tot_college,
          'totaal_reis':          tot_reis,
          'totaal_lening':        tot_len
      });

      i = new Date(i.setMonth(i.getMonth() + 1));
  }
  let obj = {
      totaalSchuld: [],
      totaalAanv: [],
      totaalColl: [],
      totaalReis: [],
      totaalLening: [],
    } 

  dataset.forEach(function(item) {
      obj.totaalSchuld.push(  [item.totaal_schuld]);
      obj.totaalAanv.push(    {x: item.date, y: item.totaal_aanvullend})
      obj.totaalColl.push(    {x: item.date, y: item.totaal_college})
      obj.totaalReis.push(    {x: item.date, y: item.totaal_reis})
      obj.totaalLening.push(  {x: item.date, y: item.totaal_lening})
    });

    //console.log(obj);
    return obj;
}

function datasetAfbouw(data){
  // TODO: CHECK IF LEENSTELSEL OF BASISBEURS
  let loopTijd = 35;
  let draagkrachtVrijeVoet = new BigNumber(1635.60);
  let percentageBovenVrijeVoet = new BigNumber(0.04);
  let rentePercentage = new BigNumber(data.rente);

  // Convert numbers to BigNumbers
  let aanvullend  = new BigNumber(data.aanvullend);
  let reisproduct = new BigNumber(data.reisproduct);
  let collegegeld = new BigNumber(data.collegegeld);
  let lening      = new BigNumber(data.lening);
  let maandloon   = new BigNumber(data.maandloon);
  let prestatiebeurs = data.prestatiebeurs;

  // Hoeveel maanden in totaal?
  let beginAflos = dayjs(new Date(data.eindMaand)).add(3, 'y').startOf('y');
  let eindAflos = dayjs(beginAflos).add(loopTijd, 'y'); 

  // Hoeveel maanden?
  let maandenAflosfase = loopTijd * 12;
  let totaalschuld;
  if(prestatiebeurs == 1) {
    totaalschuld = collegegeld.plus(lening);
  } else {
    totaalschuld = collegegeld.plus(lening).plus(aanvullend).plus(reisproduct);
  }

  // Hoeveel zou ik moeten betalen?
  function hoeveelMoetIkBetalen(date, schuld) {
    // Aflossing
    let maandenOver = eindAflos.diff(date, 'month');
    let teAflossen = new BigNumber(schuld.dividedBy(maandenOver).toFixed(2));
    // Rente
    //console.log(rentePercentage.toFixed())
    //console.log(rentePercentage.times(10000).dividedBy(12).toFixed(10));
    //console.log(rentePercentage.toString())
    let rentepermaand = rentePercentage.times(10000).dividedBy(12);
    let teRente = schuld.times(rentepermaand).dividedBy(10000);
    //console.log(rentePercentage.toFixed(2) + " Think " + teRente.toFixed(2));
    return { aflossing: teAflossen, rente: teRente};
  }

  // Hoeveel kan ik betalen?
  function hoeveelKanIkBetalen(){
    // Draagkracht = 4% van inkomen boven draagkrachtvrije voet
    // Zonder kinderen      - 100% Minimumloon 1635.60
    // Alle andere gevallen - 143% Minimumloon 2338.91

    // maandloon, draagkrachtVrijeVoet, percentageBovenVrijeVoet, rentePercentage
    let rekenbedrag = maandloon.minus(draagkrachtVrijeVoet);
    if(rekenbedrag > 5) { // Zit hier die quirk bij van minimaal 5eu?
      // Goed ik kan betalen
      return rekenbedrag.times(percentageBovenVrijeVoet);
    } else {
      return 0;
    }
  }

  let totaleSchuld = new BigNumber(totaalschuld);
  let totaleAflos = new BigNumber(0);
  let totaleRente = new BigNumber(0);
  let extraRente = new BigNumber(0);

  let dataset = [];
  let startJaar = dayjs(beginAflos).year();

  let i = 0;
  for (i = 0; i < maandenAflosfase; i++){
    // Zitten we in hetzelfde jaar?
    let huidigJaar = dayjs(beginAflos.add(i, 'month')).year();
    let jaarAflos = new BigNumber(0);
    let jaarRente = new BigNumber(0);

    // Wat zou ik deze maand moeten betalen?
    let teBetalen = hoeveelMoetIkBetalen(dayjs(beginAflos.add(i, 'month')), totaleSchuld);
    // Hoeveel kan ik betalen?
    let kanBetalen = new BigNumber(hoeveelKanIkBetalen());
    // Check voor kunnen betalen
    // Eerst Rente:
    if(kanBetalen.isGreaterThanOrEqualTo(new BigNumber(teBetalen.rente))){
      // Je kan rente Betalen
      kanBetalen = kanBetalen.minus(teBetalen.rente);
      // Voeg toe aan totaal betaalde rente
      jaarRente = jaarRente.plus(teBetalen.rente);
      totaleRente = totaleRente.plus(teBetalen.rente);

      // Kun je met de rest aflossen?
      if(kanBetalen.isGreaterThanOrEqualTo(teBetalen.aflossing)){
        // Betaal wat je moet betalen af.
        kanBetalen = kanBetalen.minus(teBetalen.aflossing);
        totaleSchuld = totaleSchuld.minus(teBetalen.aflossing);
        // Voeg toe aan totaal afgelost bedrag
        totaleAflos = totaleAflos.plus(teBetalen.aflossing);
        jaarAflos = jaarAflos.plus(teBetalen.aflossing);
      } else if (kanBetalen.isLessThan(teBetalen.aflossing)){
        // No problem, betaal wat je kunt
        teBetalen.aflossing = teBetalen.aflossing.minus(kanBetalen);
        totaleSchuld = totaleSchuld.minus(kanBetalen);
        // en voeg toe aan totalen
        totaleAflos = totaleAflos.plus(kanBetalen);
        jaarAflos = jaarAflos.plus(kanBetalen);
      }
    } else if (kanBetalen.isLessThan(teBetalen.rente)) {
      // Je kunt de rente niet betalen, betaal wat je kunt
      teBetalen.rente = teBetalen.rente.minus(kanBetalen);
      // Voeg de rest toe aan je schuld.
      totaleSchuld = totaleSchuld.plus(teBetalen.rente);
      extraRente = extraRente.plus(teBetalen.rente);

      // en voeg getallen toe aan totalen
      jaarRente = jaarRente.plus(kanBetalen);
      totaleRente = totaleRente.plus(kanBetalen);
    }

    if(huidigJaar != startJaar){
      // We zitten in een nieuw jaar: push de totalen en reset de jaardata.
      dataset.push({
          'year':                 huidigJaar,
          'loon':                 maandloon.times(12).toFixed(2),
          'loonpermaand':         maandloon.toFixed(2),
          'totaal_rente':         totaleRente.toFixed(2),
          'extra_rente':          extraRente.toFixed(2),
          'jaarRente':            jaarRente.toFixed(2),
          'jaarAflossing':        jaarAflos.toFixed(2),
          'totaal_schuld':        totaleSchuld.toFixed(2),
          'totaal_betaald':       totaleAflos.plus(totaleRente).toFixed(2),
      });

      // Reset jaartellers
      startJaar = huidigJaar;
      jaarAflos = 0;
      jaarRente = 0;
    }

      continue;
  } // end for loop

  let obj = {
    totaalSchuld: [],
    totaalRente: [],
    totaalBetaald: [],
    extraRente: [],
  } 

  dataset.forEach(function(item) {
    obj.totaalSchuld.push(  {x: item.year, y: item.totaal_schuld});
    obj.totaalRente.push(  {x: item.year, y: item.totaal_rente});
    obj.totaalBetaald.push(  {x: item.year, y: item.totaal_betaald});
    obj.extraRente.push( {x: item.year, y: item.extra_rente});
  });
  return obj;
};